import { useWalletClient, } from 'wagmi';
import { useGlobalWalletSignerAccount } from './useGlobalWalletSignerAccount.js';
export function useGlobalWalletSignerClient(parameters = {}) {
    const { address } = useGlobalWalletSignerAccount();
    const walletClient = useWalletClient({
        ...parameters,
        account: address,
    });
    return walletClient;
}
//# sourceMappingURL=useGlobalWalletSignerClient.js.map